import Image from 'next/image'
import { FC } from 'react'

import cl from './InfoSectionBlock.module.scss'

export interface InfoItem {
	title: string
	subtitle: string
	img: string
}

export const InfoSectionBlock: FC<{ data: InfoItem[] }> = ({ data }) => {
	return (
		<section className={cl.section}>
			<ul className={cl.list}>
				{data &&
					data.map((item, index) => (
						<li key={index + 'infoList'} className={cl.item}>
							<div className={cl.textWrapper}>
								<h2 className={cl.title}>{item.title}</h2>
								<p className={cl.subtitle}>{item.subtitle}</p>
							</div>

							<Image src={item.img} width={700} height={449} alt={item.title} className={cl.img} />
						</li>
					))}
			</ul>
		</section>
	)
}
